import { render, staticRenderFns } from "./waterType.vue?vue&type=template&id=37097182&"
import script from "./waterType.vue?vue&type=script&lang=js&"
export * from "./waterType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports